import React from "react";
import { useNavigate } from "react-router-dom";
import { Table, Box } from "@cloudscape-design/components";
import Button from "../../common/Button";
import Badge from "../../common/Badge";
import { RecentActivityTableProps } from "./types";
import { ActivityItem } from "../../AllActivities/types";

const RecentActivityTable: React.FC<RecentActivityTableProps> = ({
  items = [],
  loading = false,
}) => {
  const navigate = useNavigate();

  const handleViewReport = (item: ActivityItem) => {
    // Navigate to generic view page and pass report data via state
    navigate("/report/view", { state: { reportData: item } });
  };

  const columnDefinitions = [
    {
      id: "reportName",
      header: "Report/Analysis Name",
      cell: (item: ActivityItem) => (
        <Box>
          <div style={{ fontWeight: 600, marginBottom: "4px" }}>
            {item.reportName}
          </div>
          <div style={{ fontSize: "14px", color: "#5f6b7a" }}>
            {item.description}
          </div>
          <Box margin={{ top: "xs" }}>
            <Badge variant="category" color="blue">
              {item.category}
            </Badge>
          </Box>
        </Box>
      ),
      width: "50%",
      minWidth: "300px",
    },
    {
      id: "date",
      header: "Date",
      cell: (item: ActivityItem) => item.date,
      width: "20%",
      minWidth: "120px",
    },
    {
      id: "status",
      header: "Status",
      cell: (item: ActivityItem) => (
        <Badge
          variant="status"
          color={
            item.status === "Completed"
              ? "green"
              : item.status === "In Progress"
              ? "blue"
              : "red"
          }
        >
          {item.status}
        </Badge>
      ),
      width: "15%",
      minWidth: "100px",
    },
    {
      id: "actions",
      header: "Actions",
      cell: (item: ActivityItem) => (
        <Button
          variant="secondary"
          icon="external"
          onClick={() => handleViewReport(item)}
        >
          View
        </Button>
      ),
      width: "15%",
      minWidth: "80px",
    },
  ];

  return (
    <Table
      columnDefinitions={columnDefinitions}
      items={items}
      loading={loading}
      loadingText="Loading recent activity..."
      empty={
        <Box textAlign="center" color="inherit">
          <b>No recent activity</b>
          <Box padding={{ bottom: "s" }} variant="p" color="inherit">
            No reports or analyses have been run recently.
          </Box>
        </Box>
      }
      variant="borderless"
    />
  );
};

export default RecentActivityTable;
